import { SettingsImport } from './Import'
const { RoutesMap, UserRoleList, ModuleList, ActionList, AddAction, UpdateAction, Permission, CompanyPermission, UserPermission } = SettingsImport

const SettingsRoute = () => {
    return [
        {
            path: RoutesMap.MODULE_LIST.path,
            element: <ModuleList />
        },

        {
            path: RoutesMap.USER_ROLE_LIST.path,
            element: <UserRoleList />
        },

        {
            path: RoutesMap.ACTION_LIST.path,
            element: <ActionList />
        },
        {
            path: RoutesMap.ADD_ACTION.path,
            element: <AddAction />
        },
        {
            path: RoutesMap.UPDATE_ACTION.path,
            element: <UpdateAction />
        },

        {
            path: RoutesMap.PERMISSION.path,
            element: <Permission />
        },

        {
            path: RoutesMap.COMPANY_PERMISSION.path,
            element: <CompanyPermission />
        },

        {
            path: RoutesMap.USER_PERMISSION.path,
            element: <UserPermission />
        },
    ]
}

export default SettingsRoute;